import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    calendarContainer: {
        marginBlock: `calc(${tokens.spacingHorizontalSNudge} * ${-1})`,
    },
});
